import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const SalesTeamInput = () => {
  const { teamId = '' } = useParams();
  const decodedId = teamId ? atob(teamId) : teamId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesTeam';

  useEffect(() => {
    if (teamId) { setIsEditing(true); fetchDetails(); }
  }, [teamId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['salesTeam'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Sales Team details:', error); }
  };

  const fields = [
    { name: 'name', label: 'Team Name', type: 'text', cols: 2 },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { type: 'section', label: 'Leadership & Assignment' },
    {
      name: 'team_lead', label: 'Team Lead', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    {
      name: 'team_lead_status', label: 'Team Lead Status', type: 'select',
      options: [
        { value: 'isTeamLead', label: 'Is Team Lead' },
        { value: 'isNotTeamLead', label: 'Is Not Team Lead' },
      ],
    },
    {
      name: 'members', label: 'Team Members', type: 'async-multiselect',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    {
      name: 'region', label: 'Sales Region', type: 'async-select',
      endpoint: API_ROUTES.salesRegion,
      getOptionLabel: (r) => r.name,
    },
    { type: 'section', label: 'Targets & Contact' },
    { name: 'target_amount', label: 'Target Amount', type: 'number' },
    { name: 'email', label: 'Team Email', type: 'email' },
    { name: 'phone', label: 'Team Phone', type: 'text' },
  ];

  return (
    <div>
      <FormComponent
        fields={fields}
        initialFormData={formData}
        route={route}
        title={isEditing ? 'Edit Sales Team' : 'Create Sales Team'}
        subtitle="Define the team name, leadership, regional assignment, and contact details."
      />
    </div>
  );
};

export default SalesTeamInput;
